import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";
import { Query } from "_shared/_api/queries/query";
import FeeSchedulesFilterParameters from "work/fee-schedules/_api/queries/contracts/filtering/fee-schedules-filter-parameters";
import FeeSchedulesOrderParameters from "work/fee-schedules/_api/queries/contracts/ordering/fee-schedules-order-parameters";


export default class FeeSchedulesQuery extends Query<
  FeeSchedulesFilterParameters,
  FeeSchedulesOrderParameters,
  PaginationParameters
> {
  public constructor(params: {
    filterParameters: FeeSchedulesFilterParameters;
    orderParameters: FeeSchedulesOrderParameters;
    paginationParameters: PaginationParameters;
  }) {
    super(params);
  }

  isEqualTo(other: FeeSchedulesQuery): boolean {
    if (!other || !(other instanceof FeeSchedulesQuery)) {
      return false;
    }
    return (
      this.filterParameters.isEqualTo(other.filterParameters) &&
      this.orderParameters.isEqualTo(other.orderParameters) &&
      this.paginationParameters.isEqualTo(other.paginationParameters)
    );
  }
}
